/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  UpdateTenantDetailsByIDOptions,
  UpdateTenantDetailsByIDStatus200,
  UpdateTenantDetailsByIDStatus400,
  UpdateTenantDetailsByIDStatus404,
  UpdateTenantDetailsByIDStatus500,
} from '../types/UpdateTenantDetailsByID'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { updateTenantDetailsByID } from '../clients/updateTenantDetailsByID'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const updateTenantDetailsByIDMutationKey = () => [{ url: '/v1/tenants/:tenant_id' }] as const

export function updateTenantDetailsByIDMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = updateTenantDetailsByIDMutationKey()
  return mutationOptions<
    UpdateTenantDetailsByIDStatus200,
    ResponseErrorConfig<
      | UpdateTenantDetailsByIDStatus400
      | UpdateTenantDetailsByIDStatus404
      | UpdateTenantDetailsByIDStatus500
    >,
    UpdateTenantDetailsByIDOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ path, body }) => {
      return updateTenantDetailsByID({ ...config, path, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @summary Update tenant details by ID
 * {@link /v1/tenants/:tenant_id}
 */
export function useUpdateTenantDetailsByID<TContext>(
  options: {
    mutation?: UseMutationOptions<
      UpdateTenantDetailsByIDStatus200,
      ResponseErrorConfig<
        | UpdateTenantDetailsByIDStatus400
        | UpdateTenantDetailsByIDStatus404
        | UpdateTenantDetailsByIDStatus500
      >,
      UpdateTenantDetailsByIDOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? updateTenantDetailsByIDMutationKey()

  const baseOptions = updateTenantDetailsByIDMutationOptions(config) as UseMutationOptions<
    UpdateTenantDetailsByIDStatus200,
    ResponseErrorConfig<
      | UpdateTenantDetailsByIDStatus400
      | UpdateTenantDetailsByIDStatus404
      | UpdateTenantDetailsByIDStatus500
    >,
    UpdateTenantDetailsByIDOptions,
    TContext
  >

  return useMutation<
    UpdateTenantDetailsByIDStatus200,
    ResponseErrorConfig<
      | UpdateTenantDetailsByIDStatus400
      | UpdateTenantDetailsByIDStatus404
      | UpdateTenantDetailsByIDStatus500
    >,
    UpdateTenantDetailsByIDOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    UpdateTenantDetailsByIDStatus200,
    ResponseErrorConfig<
      | UpdateTenantDetailsByIDStatus400
      | UpdateTenantDetailsByIDStatus404
      | UpdateTenantDetailsByIDStatus500
    >,
    UpdateTenantDetailsByIDOptions,
    TContext
  >
}
